import { Box, Paper, Typography } from '@material-ui/core';

import { FormQuestion, MultipleChoiceListDataPoint, Visualization } from '@vyce/core/src/types';
import { AppCheckbox } from '@vyce/core/src/components/inputs/AppCheckbox';

import { FormResultResponses } from './FormResultResponses';

export const FormResultMultipleChoice = ({
  question,
  visualization,
}: {
  question: FormQuestion;
  visualization: Visualization | undefined;
}) => {
  const getOptionCount = (optionLabel: string): number => {
    if (visualization?.type !== 'multiple_choice_list') return 0;
    const chartData = visualization.data as MultipleChoiceListDataPoint[];
    const dataPoint = chartData?.find(point => point.label === optionLabel || point.value === optionLabel);
    return dataPoint?.count || 0;
  };

  const noAnswersCount =
    visualization?.type === 'multiple_choice_list'
      ? (visualization.data as MultipleChoiceListDataPoint[]).filter(point => !point.value).length
      : 0;

  const paperStyle = {
    padding: 24,
    width: '100%',
    height: '100%',
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  return (
    <Box width="100%">
      {question.answer.options?.map(option => (
        <Paper
          key={option.id}
          variant="outlined"
          style={{
            ...paperStyle,
          }}
        >
          <Box display="flex" alignItems="center" gridGap={8}>
            <AppCheckbox disabled checked={true} />
            <Typography variant="body1" color="textSecondary">
              {option.label}
            </Typography>
          </Box>

          <FormResultResponses count={getOptionCount(option.label)} names={[]} />
        </Paper>
      ))}

      <Paper variant="outlined" style={{ ...paperStyle }}>
        <Typography variant="body1" color="textSecondary">
          No answers
        </Typography>

        <FormResultResponses count={noAnswersCount} names={[]} />
      </Paper>
    </Box>
  );
};
